import { ComponentCategory, ComponentType } from '../../types';

export default {
  name: ComponentType.FormSelect,
  title: 'Select',
  category: ComponentCategory.FormControls,
};
